module.exports = __webpack_public_path__ + "img/Microphone.1be53c6d.png";